var _rect, _rect2, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBulletPointCompleted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#4720B7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "url(#paint0_linear_10629_11869)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.499 14.6895L8.02925 12.2197L6.96875 13.2802L10.499 16.8105L17.7793 9.53023L16.7187 8.46973L10.499 14.6895Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10629_11869",
    x1: -5.4,
    y1: -3,
    x2: 26.4,
    y2: 34.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4720B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#907ACF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulletPointCompleted);
export default __webpack_public_path__ + "static/media/bullet-point-completed.d86957de81fe1591a15e16cde995ca0f.svg";
export { ForwardRef as ReactComponent };